import {
	ButtonSubmit,
	ColourStateSolid,
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FlexGap,
	Modal,
	ModalType,
	SelectItemType,
	StackVertical,
	UploadFile,
} from '@ukpostbox/frontend-framework';
import { Controller, FieldValues, FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';

function AddDocumentToBatchModal(props: ModalType) {
	const { uploadingShippingDocument, AddDocumentToBatch, GetUserDocumentTypes, userDocumentTypes } =
		useForwardingBatchProvider();

	const formMethods = useForm({
		defaultValues: {
			file: null,
			documentType: -1,
		},
	});

	const HandleAttachDocument = (data: FieldValues) => {
		const file = formMethods.getValues('file');

		if (file) {
			AddDocumentToBatch(file, formMethods.getValues('documentType'), props.closeCallback);
		}
	};

	useEffect(() => {
		formMethods.reset();
		if (props.isOpen) {
			GetUserDocumentTypes();
		}
	}, [props.isOpen]);

	return (
		<Modal title='Attach Document' isOpen={props.isOpen} closeCallback={props.closeCallback}>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit((data: FieldValues) => HandleAttachDocument(data))}>
					<fieldset>
						<StackVertical gap={FlexGap.Medium}>
							<Controller
								control={formMethods.control}
								name='documentType'
								rules={{ required: 'A file is required', min: 0 }}
								render={({ field }) => (
									<ComboBoxControl
										loading={!userDocumentTypes}
										data={userDocumentTypes?.documentTypes as Array<SelectItemType>}
										valueType='string'
										name='documentType'
										forwardValueCallback={(e) => field.onChange(e)}
										placeholder='Select Document Type...'
										displayType={ComboBoxTypeEnum.Single}
										displayItemLabelType={ComboBoxItemDisplayEnum.Label}
										formReset={props.isOpen}
									/>
								)}
							/>

							<Controller
								control={formMethods.control}
								name='file'
								rules={{ required: 'A file is required' }}
								render={({ field }) => (
									<UploadFile
										name='addFile'
										onChange={(e: any) => field.onChange(e)}
										acceptsFileExtension={['.pdf']}
										extensionDisplayValue='PDF'
										reset={props.isOpen}
										onError={(errorState: boolean) => console.log(errorState)}
										maxFiles={1}
									/>
								)}
							/>

							<ButtonSubmit
								loading={uploadingShippingDocument}
								disabled={uploadingShippingDocument || !formMethods.formState.isValid}
								colour={ColourStateSolid.Primary}
								fullWidth
								title='Upload'
							/>
						</StackVertical>
					</fieldset>
				</form>
			</FormProvider>
		</Modal>
	);
}

export { AddDocumentToBatchModal };
